export default __webpack_public_path__ + "static/media/heroImgCR3.27230c77.jpg";